import React from 'react';
import {
  Box,
  TextField,
  FormHelperText,
  Grid,
  Typography,
  Alert,
} from '@mui/material';

const DynamicVariantFields = ({
  value = {},
  onChange = () => {},
  formData = {},
  sourceSection = 'Variant Attributes Definition',
  sourceField = 'Variant Attributes',
  helperText = '',
  error = false,
  errorText = '',
  disabled = false,
}) => {
  // Get the variant attributes defined in the previous section
  const variantAttributes = formData[sourceField] || [];

  // If no attributes defined, show a message
  if (!Array.isArray(variantAttributes) || variantAttributes.length === 0) {
    return (
      <Alert severity="info" sx={{ width: '100%' }}>
        <Typography variant="body2">
          <strong>No variant attributes defined yet.</strong>
          <br />
          Please define variant attributes in the "{sourceSection}" section above first.
        </Typography>
      </Alert>
    );
  }

  // Handle change for a specific attribute
  const handleAttributeChange = (attributeName, newValue) => {
    const updatedValue = {
      ...(value || {}),
      [attributeName]: newValue,
    };
    onChange(updatedValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        {variantAttributes.map((attribute, index) => {
          const attributeName = attribute['Attribute Name'];
          const currentValue = value?.[attributeName] || '';

          if (!attributeName) return null;

          return (
            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
              <TextField
                fullWidth
                label={attributeName}
                value={currentValue}
                onChange={(e) => handleAttributeChange(attributeName, e.target.value)}
                placeholder={`Enter ${attributeName.toLowerCase()}...`}
                error={error}
                disabled={disabled}
                helperText={`Enter the ${attributeName.toLowerCase()} for this variant`}
              />
            </Grid>
          );
        })}
      </Grid>

      {(helperText || errorText) && (
        <FormHelperText error={error} sx={{ mt: 1 }}>
          {error ? errorText : helperText}
        </FormHelperText>
      )}

      {error && !errorText && (
        <FormHelperText error sx={{ mt: 1 }}>
          Please enter values for all variant attributes
        </FormHelperText>
      )}
    </Box>
  );
};

export default DynamicVariantFields;

